'use client'

import { useMemo, useState } from 'react'
import { calcDecking } from '@/lib/calculators/formulas'
import { ToolField, ToolResultCard, ToolResultRow, toolCurrency, toolFmt, toolNum } from './tool-inputs'

export function DeckingCalculatorTool() {
  const [length, setLength] = useState('5')
  const [width, setWidth] = useState('4')
  const [boardW, setBoardW] = useState('140')
  const [gap, setGap] = useState('5')
  const [waste, setWaste] = useState('10')
  const [boardPrice, setBoardPrice] = useState('85')

  const r = useMemo(() => calcDecking(
    toolNum(length), toolNum(width), toolNum(boardW), toolNum(gap),
    0.45, 0.4, toolNum(boardPrice), 0, 0, 0, toolNum(waste),
  ), [length, width, boardW, gap, waste, boardPrice])

  return (
    <div className="grid gap-6 md:grid-cols-[1fr_380px] md:items-start">
      <div className="space-y-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Deck size</h2>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <ToolField label="Length" value={length} onChange={setLength} unit="m" />
            <ToolField label="Width" value={width} onChange={setWidth} unit="m" />
          </div>
        </div>
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Boards</h2>
          <div className="mt-3 grid grid-cols-3 gap-3">
            <ToolField label="Board width" value={boardW} onChange={setBoardW} unit="mm" step="5" hint="e.g. 140" />
            <ToolField label="Gap" value={gap} onChange={setGap} unit="mm" step="1" hint="3–6 mm" />
            <ToolField label="Waste" value={waste} onChange={setWaste} unit="%" />
          </div>
          <div className="mt-3">
            <ToolField label="Board price" value={boardPrice} onChange={setBoardPrice} unit="R/m" />
          </div>
        </div>
      </div>

      <ToolResultCard title="Your decking estimate">
        <ToolResultRow label="Deck area" value={`${toolFmt(r.areaM2, 1)} m²`} />
        <ToolResultRow label="Deck boards (rows)" value={`${r.boardCount} rows`} />
        <ToolResultRow label="Board length to buy" value={`${toolFmt(r.boardRunM, 1)} m`} />
        <ToolResultRow label="Estimated board cost" value={toolCurrency(r.boardCost)} strong />
      </ToolResultCard>
    </div>
  )
}
